import Class from './c-chart-stack-column-view';
import './c-chart-stack-column-view@.vue';

export default Class;